class Contact extends Component {
	constructor(el) {
		super(el);
		this.switchesHolder = this.$find('[data-contact-tab-switchers]');
		this.switches = this.switchesHolder.querySelectorAll('[data-contact-tab-switch]');
		this.tabs = this.$findAll('[data-contact-tab-tab]');
		this._init();
	}

	resetTabs() {
		this.switches.forEach(switchEl => switchEl.classList.remove('is-active'));
		this.tabs.forEach(tab => tab.classList.remove('is-active'));
	}

	activeTab(hash, scrollIntoView = false) {
		const activeTab = [...this.tabs].find(item => item.id === hash.substr(1));
		if (!activeTab) return;
		this.resetTabs();
		activeTab.classList.add('is-active');
		const activeSwitch = [...this.switches].find(item => item.hash === hash)
		activeSwitch && activeSwitch.classList.add('is-active');
		scrollIntoView && activeTab.scrollIntoView({behavior: 'smooth'});
	}

	onSwitchClicked(e, switchEl) {
		e.preventDefault();
		history.pushState({}, '', switchEl.hash);
		this.activeTab(switchEl.hash);
	}

	_init() {
		location.hash && this.activeTab(location.hash);
		this.addEventListeners();
	}

	addEventListeners() {
		this.switches.forEach(switchEl => switchEl.addEventListener('click', (e) => this.onSwitchClicked(e, switchEl)));
		window.addEventListener('hashchange', () => {
			this.activeTab(location.hash, true);
		}, false);
	}
}
